import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, CardFooter, Row, Col, Button, Modal, ModalBody, ModalFooter } from "reactstrap";

//api
import { api_GET } from "../../services/api_service.js";

// services
import { showMessage } from "../../services/message.js";

// Components
import DadosPrimarios from "../Shared/DadosPrimarios";
import CardOpcaoCadastro from "./components/CardOpcaoCadastro";
import CardIntegracao from "./components/CardIntegracao";

//Context
import { useAuth } from "../../context/auth";

export default function PortalOpcoes({ history }) {
  const { signOut, setupSistema } = useAuth();

  //Opções de integração (RGG, RCC, RSS)
  const [integracaoSelecionada, set_integracaoSelecionada] = useState(null);
  const [integracoes, set_integracoes] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const toogleShowModal = () => setShowModal(!showModal);

  const LoadIntegracoes = () => {
    api_GET('categoria/GetOpcoesIntegracao')
      .then(result => set_integracoes(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
  }

  //Opções de Setup Solicitação
  const [opcaoSelecionada, set_opcaoSelecionada] = useState(null);
  const [opcoes, set_opcoes] = useState([]);

  const LoadOpcoes = () => {
    api_GET('categoria/GetListByExistsSetupSolicitacao')
      .then(result => set_opcoes(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
  }


  useEffect(() => {
    signOut(false, null);
    LoadOpcoes();
    LoadIntegracoes();
  }, []);


  const [subTitle, setSubTitle] = useState("");
  
  return (
    <>
      {!integracaoSelecionada &&
        <div className="content" style={{ marginTop: "50px" }}>
          <Row>
            <Col lg="12" >
              <p className="mb-2" style={{ fontWeight: "bold", fontSize: "23px" }}>
                Cadastramento de Geradores de Resíduos Especiais
              </p>
            </Col>
          </Row>
          <Row style={{ justifyContent: "center" }} className="h-auto">
            {integracoes.map((m, key) => (
              <CardIntegracao
                key={key}
                indice={key}
                integracao={m}
                handleClickIntegacao={() => {
                  setSubTitle(m)
                  set_integracaoSelecionada(m);
                  if (m == "RGG")
                    setShowModal(true)
                }}
              />
            ))
            }
          </Row>
          <Row className="mt-3">
            <Col lg="12">
              <p className="mb-2" style={{ fontWeight: "bold", fontSize: "23px" }}>
                Gestão Geradores de Resíduos Especiais
              </p>
            </Col>
          </Row>
          <Row className="h-auto">
            <Col lg="6" md="6" sm="6" className="d-flex">
              <Card className="card-stats card-box flex-fill">
                <CardHeader className="titulo-card mx-3" style={{ fontSize: "1.3em", opacity: "0.8" }}>
                  <i className="fas fa-city mr-5"></i> Resíduos Construção Civil (RCC)
                </CardHeader>
                <hr className="mb-0" />
                <CardBody className="text-center">
                  Sistema de gestão de resíduos da construção civil
                </CardBody>
                <CardFooter className="text-center mt-2">
                  <Button color="success" onClick={() => window.open("https://rcc-spregula.coletas.online/", "_blank")}>Acessar</Button>
                </CardFooter>
              </Card>
            </Col>

            <Col lg="6" md="6" sm="6" className="d-flex">
              <Card className="card-stats card-box flex-fill">
                <CardHeader className="titulo-card mx-3" style={{ fontSize: "1.3em", opacity: "0.8" }}>
                  <i class="fas fa-trash-alt mr-5"></i> Resíduos Grande Gerador (RGG)
                </CardHeader>
                <hr className="mb-0" />
                <CardBody className="text-center" >
                  Cadastramento de grandes geradores, transportadoras e destinos finais da coleta privada
                </CardBody>
                <CardFooter className="text-center mt-2">
                  <Button color="success" onClick={() => window.open("https://spregula-rgg.coletas.online/", "_blank")}>Acessar</Button>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
      }

      {integracaoSelecionada && !opcaoSelecionada &&
        <>
          <Modal
            isOpen={showModal}
            toggle={toogleShowModal}
            size={"lg"}
            centered
          >
            <ModalBody>
              <h4 className="text-danger mt-1 fw-bold">ATENÇÃO</h4>
              <span className="text-danger">Em caso de dúvidas ou para ter acesso aos manuais de orientação do Recadastramento, por favor, acesse nossa opção Dúvidas <strong className="text-danger" style={{ cursor: "pointer" }} onClick={() => history.push("./duvidas")}>cliclando aqui.</strong></span>

            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toogleShowModal}>OK</Button>
            </ModalFooter>
          </Modal>
          <div className="content" style={{ marginTop: "50px" }}>
            <Row>
              <Col lg="12" md="12" >
                <Card className="card-stats">
                  <CardBody>
                    <h2 className="titulo-solicitacao mb-0">CADASTRE-SE</h2>
                    <Row className="text-center pb-4">
                      {subTitle != "" &&
                        <Col md="12" className="text-danger mb-0 pt-0">
                          <h4 className="m-0">Cadastro de {subTitle}</h4>
                        </Col>
                      }
                      <Col md="12" className="mt-0 pt-0">
                        Solicitação de Requerimento para criar Cadastro {setupSistema?.identificacao}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row style={{ justifyContent: "center" }}>
              {opcoes.filter(f => f.sigla == integracaoSelecionada).map((m, key) => (
                <CardOpcaoCadastro
                  key={key}
                  indice={key}
                  opcao={m}
                  handleClickOpcao={() => {
                    setSubTitle(m)
                    set_opcaoSelecionada(m)
                  }}
                />
              ))
              }
            </Row>
          </div>

        </>
      }

      {opcaoSelecionada &&
        <DadosPrimarios
          opcao={opcaoSelecionada}
        />
      }
    </>
  );
}
